function Banner() {
  return (
    <div className="py-8 md:py-4 lg:py-0 relative w-full h-full">
      {/* 第一張圖：上下左右置中 + 逆時針旋轉動畫 */}
      <img
        src="./lookie.webp"
        className="w-6 h-6 md:w-8 md:h-8 lg:w-12 lg:h-12 xl:w-16 xl:h-16 absolute top-[30%] left-[48%] transform -translate-x-1/2 -translate-y-1/2 animate-rotate"
        alt="lookie"
      />
      {/* 第二張圖：banner */}
      <img src="./banner.webp" className="w-full" alt="banner" />
    </div>
  );
}

export default Banner;
